import { IpcMessage } from '@flowus/shared';
import type { FC } from 'react';
import { Button } from 'src/common/components/button';
import { Icon } from 'src/common/components/icon';
import { ipcSendMessage, isFlowUsApp } from 'src/utils/electron-util';

export const PageOfflineEmpty: FC = () => {
  return (
    <div className="cursor-default login-wrapper">
      <OfflineEmpty />
    </div>
  );
};

export const OfflineEmpty: FC = () => {
  const refresh = () => {
    if (isFlowUsApp.check) {
      ipcSendMessage(IpcMessage.Reload);
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="flex flex-col items-center w-full">
      <div className="leading-[80px]">
        <Icon className="text-grey4 text-[70px]" name="IcNetworkOutage" size="auto" />
      </div>
      <div className="text-grey4 text-t1">你已离线</div>
      <div className="text-grey4 text-t2 mt-1">如果网络正常，可尝试开关Wi-Fi来恢复正常</div>
      <Button className="mt-4" onClick={refresh}>
        <span className="text-grey3 text-t2">刷新页面</span>
      </Button>
    </div>
  );
};
